<template>
  <div>
    <div class="d-flex justify-content-start align-items-end mb-2">
      <b-form-group label="Company" class="mr-2">
        <b-form-input v-model="filtersObj.companyName" size="sm" type="text" @input="onSearch"></b-form-input>
      </b-form-group>
      <b-form-group label="Status" class="mr-2">
        <b-form-select @change="onSearch" v-model="filtersObj.isClosedRefund" size="sm">
          <option :value="null">All</option>
          <option :value="false">Open</option>
          <option :value="true">Close</option>
        </b-form-select>
      </b-form-group>
      <!-- <b-form-group label="Invoice No" class="mr-2">
        <b-form-input v-model="filtersObj.invoiceId" size="sm" type="text" @input="onSearch"></b-form-input>
      </b-form-group>
      <b-form-group label="Purchase Order No" class="mr-2">
        <b-form-input v-model="filtersObj.purchaseOrderId" size="sm" type="text" @input="onSearch"></b-form-input>
      </b-form-group> -->
      <date-range-picker :dateFrom="filtersObj.dateFrom" :dateTo="filters.dateTo" @handleSearch="onSearch"></date-range-picker>
      <div class="clear-filter-button-container">
        <b-button size="sm" @click="handleClearFilter">Clear filters</b-button>
      </div>
    </div>
    <h6 v-if="!filtersObj.isClosedRefund">Select a row to refund a customer.</h6>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :canEdit="checkClaim(CAN_EDIT_CREDIT_MEMO)"
      :canDelete="checkClaim(CAN_DELETE_CREDIT_MEMO)"
      :gridId="gridId"
      :pageable="pageable"
      :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
      :take="pageInfo.pageSize"
      :itemData="itemData"
      :pageSizes="pageInfo.pageSize"
      :totalItems="pageInfo.totalItems"
      :fields="fields"
      :sortBy="pageInfo.sortBy"
      :sortOrder="pageInfo.sortOrder"
      :sortMethod="sortGrid"
      :onDelete="onDelete"
      :onEdit="onEdit"
      :handleRowClick="handleRowClick"
      @getData="onGetData"
      :styleCustom="'height: 335px'"
      :isTblLoader="tblLoader"
    />
    <b-modal id="refund-modal" size="sm" ref="refund-modal" title="Refund Customer" centered
      ok-title="Refund Customer" @ok="refundCustomer">
        <table style="width:100%">
          <tr>
            <th>Company</th>
            <th>Reference</th>
            <th>No.</th>
            <th>Amount</th>
          </tr>
          <tr>
            <td>{{ selectedRefund.companyName }}</td>
            <td>{{ creditMemoReference }}</td>
            <td>{{ creditMemoReferenceId }}</td>
            <td>{{ selectedRefund.amount }}</td>
          </tr>
        </table>
        <b-row v-if="selectedRefund.isClosedRefund == 0">
          <b-col>
            <h6></h6>
            <b-form-group label="Refund from" label-cols="3" label-align="right">
              <b-form-select v-model="formObj.refundFromAccount">
                <option :value="null"></option>
                <option
                  v-for="option in sortSelect(bankAccounts, 'accountName')"
                  :key="option.name"
                  :value="option.id"
                >{{option.accountName}}
                </option>
              </b-form-select>
            </b-form-group>
            <b-form-group label-cols="3" label-align="right" label="Amount">
              <b-form-input type="number" v-model="formObj.amount"
              @blur="formObj.amount = formObj.amount > selectedRefund.balance ? selectedRefund.balance : formObj.amount < 0 ? 0 : formObj.amount" />
            </b-form-group>            
          </b-col>
        </b-row>
        <h6 v-if="!selectedRefund.isClosedRefund" class="mt-1">Note: Submitting this form will close this refund record</h6>            
        <template slot="modal-footer">
          <b-button
            variant="secondary"
            :disabled="isRefunding"
            @click="closeRefundModal"
          >
            {{selectedRefund.isClosedRefund ? 'Close' : 'Cancel'}}
          </b-button>
          <b-button
            v-if="!selectedRefund.isClosedRefund"
            :disabled="isRefunding"
            variant="primary"
            @click="refundCustomer"
          >
          <i v-if="isRefunding" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
            Refund
          </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import debounce from 'lodash/debounce';
  import { GRID_PAGE_SIZES, GRID_ID } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import DateRangePicker from '@/shared/components/DateRangePicker/IndexNew';
  import gridFields from '../../fields';
  import { ACCOUNT_TYPES } from '@/pages/Accounting/components/ChartsOfAccounts/constants';

  const SEARCH_DEBOUNCE_TIME = 750;

  export default {
    name: 'RefundMemos',
    components: {
      GridSettings,
      GridComponent,
      DateRangePicker,
    },
    metaInfo: () => ({
      title: 'Refund CreditMemos',
    }),
    data() {
      return {
        fields: gridFields,
        gridId: GRID_ID.REFUND_CREDITMEMOS,
        pageable: {
          pageSizes: GRID_PAGE_SIZES,
        },
        selectedRowItemId: 0,
        filterPageName: 'refundCreditMemoPage',
        selectedRefund: {
          companyName: null,
          amount: 0,
          balance: 0,
          isClosedRefund: -1
        },
        reference: [
          'rmaId', 'vendorRMAId', 'salesOrderId', 'invoiceId',
          'purchaseOrderId', 'serviceOrderId', 'paymentId',  'billPaymentId'
        ],
        creditMemoReference: null,
        creditMemoReferenceId: null,
        formObj: {},
        bankAccounts: [],
        isRefunding: false
      };
    },
    props: {
      refreshGrid: {
        type: [String, Number],
        default: 0,
      },
    },
    computed: {
      ...mapGetters('creditMemos', [
        'gridList',
        'creditMemo',
        'pageInfo',
        'filters',
        'tblLoader'
      ]),
      ...mapGetters('account', ['gridSettingsById']),

      itemData() {
        if(this.gridList == undefined || this.gridList.length === 0) return [];
        return this.gridList.filter(x => x.isRefund == true).map((CreditMemo) => ({ ...CreditMemo, selected: CreditMemo.id === this.selectedRowItemId }));
      },
      filtersObj() {
        return this.filters[this.filterPageName] || {}
      },
    },
    methods: {
      ...mapMutations('creditMemos', [
        'setItem'
      ]),
      ...mapActions('creditMemos', ['getAll',
        'manageCreditMemo',
        'sortGrid',
        'deleteCreditMemo',
        'search',
        'refundCreditMemo'
        ]),
      ...mapActions('chartsOfAccounts', ['getMultiAccounts']),
      ...mapActions('account', ['saveGridSettings']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      onSearch: debounce(function(data = false) {
        if(typeof data === 'object') { Object.assign(this.filters,data) }
        this.filtersObj.isRefund = true;
        this.search({'filters':this.filtersObj,page:this.filterPageName});
      }, SEARCH_DEBOUNCE_TIME),

      async handleClearFilter() {
        this.clearObject(this.filtersObj);
        this.filtersObj.isRefund = true;
        this.filtersObj.isClosedRefund = 0;
        this.rmaReference = null;
        this.selectedRefund = {};
        this.search({'filters':this.filtersObj,page:this.filterPageName});
      },
      onEdit(row) {
        //this.setCreditMemo(props);
        //this.$bvModal.show('credit-memo-modal');
      },
      async handleRowClick({ dataItem }) {
        
        this.selectedRefund = dataItem;
        this.formObj = dataItem;
        for (let i in this.reference) {
          let key = this.reference[i];
          if (dataItem[key] != null) {
            this.creditMemoReferenceId = dataItem[key];
            this.creditMemoReference = (key.substring(0, key.length - 2)).replace(/([A-Z])/g, ' $1').trim();
            break;
          }
        }
        this.$refs['refund-modal'].show();
      },
      async refundCustomer() {
        this.isRefunding = true;
        await this.refundCreditMemo(this.formObj).then((res) => {
          if (res.status == 200) {
            this.getAll({});
            this.closeRefundModal();  
          }
          
        });

      },
      async onDelete(row) {
        const deleteConfirmed = await this.openConfirmBox({message:'Are you sure you want to delete record?  This action cannot be undone.'});
        if (deleteConfirmed) {
          await this.deleteCreditMemo(row.id);
          //Get the data
          this.updateList();
        }
      },
      async onGetData(params) {
        await this.getAll(params);
      },
      async updateList() {
         await this.getAll({});
      },
      closeRefundModal() {
        this.$refs['refund-modal'].hide();
        this.selectedRefund = this.formObj = this.creditMemoReference = this.creditMemoReferenceId = null;
        this.isRefunding = false; 
      }
    },
    watch:{
      refreshGrid(value){
        if(value == 1){
          this.updateList()
        }
      }
    },
    async mounted() {
      this.setItem({ resource:'filterPage', payload: this.filterPageName });

      this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
      this.getMultiAccounts([
        `accountIds=${ACCOUNT_TYPES["Bank"]}`, 
        `accountIds=${ACCOUNT_TYPES["Credit Card"]}`
      ]).then((result) => this.bankAccounts = result.data);
      await this.getAll({});
    }
  }
</script>

<style scoped>

</style>